import React from 'react';
import { Route } from 'react-router-dom';
import { getIsUserLoggedIn } from '../utils/cookie';
import { ROUTES } from '../constants';
import {
  redirectToPath,
  getPathName,
  isFeatureSwitchOn,
} from '../utils/window';

function AuthProtectedRoute({ component: Component, ...rest }: Object) {
  const redirectToUrl = isFeatureSwitchOn('ENABLE_AUTH_SIGNIN')
    ? `${ROUTES.PATH.AUTH_SIGNIN}?redirect=${getPathName()}`
    : ROUTES.PATH.AUTH_SIGNIN;

  return (
    <Route
      {...rest}
      render={(props: Object) =>
        getIsUserLoggedIn() ? (
          <Component {...props} />
        ) : (
          redirectToPath(redirectToUrl)
        )
      }
    />
  );
}

export default AuthProtectedRoute;
